export default {"src":"/_next/static/media/li.17130af2.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};